export const SOMETHING_WENT_WRONG = "Something Went Wrong...";
export const SUCCESS = "Success";